import { ITestimonial } from '@/interfaces/entities/testimonal';
import { ApiRequestConfig, apiService } from './api.service';

import { IApiService } from '@/interfaces/services/IApiService';

class TestimonialService {
    api: IApiService<ApiRequestConfig>;

    constructor(api: IApiService<ApiRequestConfig>) {
        this.api = api;
    }

    async getAllTestimonials(pageNumber: number, config?: ApiRequestConfig) {
        return await this.api.get<{ data: ITestimonial[]; pageCount: number }>(
            `/testimonial/admin?page[number]=${pageNumber}&sort[id]=DESC`,
            config,
        );
    }

    async deleteTestimonial(id: number) {
        return await this.api.delete(`/testimonial/admin/${id}`);
    }

    async editTestimonial(id: number, testimonial: FormData) {
        return await this.api.patch(`/testimonial/admin/edit/${id}`, testimonial, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        
    }

    async newTestimonial(testimonial: FormData) {
        return await this.api.post(`/testimonial/admin/create`, testimonial, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

       async changeStatus(id: number, status: string, config?: ApiRequestConfig) {
            return await this.api.patch<ITestimonial>(
                `/testimonial/admin/status/${id}`,
                { status },
                config,
            );
        }
}

export const testimonialService = new TestimonialService(apiService);